var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPointIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    rx: 12.5,
    fill: "#11B55F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.60938 18V6.6875H12.8594C15.4531 6.6875 16.8438 8.26562 16.8438 10.4375C16.8438 12.6094 15.4375 14.1719 12.8281 14.1719H10.6406V18H8.60938ZM10.6406 12.5H12.5469C14.0781 12.5 14.7656 11.6406 14.7656 10.4375C14.7656 9.21875 14.0781 8.39062 12.5469 8.39062H10.6406V12.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPointIcon);
export default __webpack_public_path__ + "static/media/pointIcon.f123d24c86699395b051f1cd1231ff4e.svg";
export { ForwardRef as ReactComponent };